module.exports = __webpack_public_path__ + "img/slika52.07a92e2c.jpg";